import CMSData from "./cms-data"
import Localization from "aldoo-ra/Localization"
import { usePageContext } from "vike-react/usePageContext"

/** A bundle's `data` as a map: it may be stored as a map or as a [{ key, value }] list. */
const asMap = (raw) => {
  if (!Array.isArray(raw)) return raw
  return raw.reduce((acc, item) => {
    if (item && item.key != null) acc[item.key] = item.value
    return acc
  }, {})
}

/**
 * Get a text bundle from the CMS and return the content
 *
 * A page that rendered the bundle on the server (./text-bundle-ssr.js puts
 * it in the page context as `ssrTextBundles`) answers from that copy until
 * the bundle has loaded in the browser — on the server, and on the first
 * client render, so the page opens in its language instead of switching to
 * it. The copy is for the language the page was rendered in: after a
 * language switch the bundle answers once it has loaded in the new one.
 * @param {*} param0
 */
const TextBundle = ({ id }) => {
  const { data } = CMSData({
    contentType: "TextBundle",
    match: { "content.id": id },
  })
  const { currentLanguage } = Localization()
  let pageContext = null
  try {
    pageContext = usePageContext()
  } catch {
    // outside a Vike page (tests, a preview): no server copy
  }

  const loaded = asMap(data[0]?.data)
  if (loaded) return loaded

  const ssr = pageContext?.ssrTextBundles
  const sameLanguage = typeof window === "undefined" || !currentLanguage || currentLanguage === ssr?.language
  return sameLanguage ? ssr?.bundles?.[id] : undefined
}

export default TextBundle
